<mat-card appearance="outlined">
  <section>
    <div class="flex flex-row gap-6 my-8" style="font-size:larger">
      <h3>Reports</h3>
    </div>
  </section>
  <section>
    <mat-tab-group dynamicHeight [(selectedIndex)]="reportsService.currentTab">

      <mat-tab label="License / Cash Reports" *ngIf="tabVisible('licenseCash')">
        <app-licenseCashReports></app-licenseCashReports>
      </mat-tab>

      <mat-tab label="Proficiency Reports" *ngIf="tabVisible('proficiencyReports')">
        <app-proficiencyReports></app-proficiencyReports>
      </mat-tab>

      <mat-tab label="Survey Reports" *ngIf="tabVisible('surveyReports')">
        <app-surveyReports></app-surveyReports>
      </mat-tab>

      <mat-tab label="Mailing Labels" *ngIf="tabVisible('mailingLabels')">
        <app-mailingLabels></app-mailingLabels>
      </mat-tab>

      <mat-tab label="Demographic Report" *ngIf="tabVisible('demographicReport')">
        <app-demographicsReport></app-demographicsReport>
      </mat-tab>

    </mat-tab-group>
  </section>
</mat-card>